/* eslint-disable react/jsx-props-no-spreading */
import {
    useEffect,
} from 'react'

import {
    useDispatch,
} from 'react-redux'

import {
    RequestStatuses,
} from 'app/enums/common.enums'

import {
    FormError,
} from 'app/types/common.types'
import {
    hideMessage,
} from '../store/formStatuses.slice'
import FailureMessage from './FailureMessage'
import SuccessMessage from './SuccessMessage'

type Props = {
    status: RequestStatuses;
    id: string;
    title?: string;
    statusCode: number,
    errors?: FormError[] | string,
    hideTimeout?: number,
}
const defaultProps: Partial<Props> = {
    hideTimeout: 5000,
}
const FinishedMessage = ({
    status,
    hideTimeout,
    ...rest
}: Readonly<Props>) => {
    const dispatch = useDispatch()

    useEffect(() => {
        const timeout = setTimeout(() => {
            dispatch(hideMessage({
                id: rest.id,
            }))
        }, hideTimeout)

        return () => {
            return clearTimeout(timeout)
        }
    }, [
        rest.id,
        dispatch,
        hideTimeout,
    ])

    if (status === RequestStatuses.SUCCESS) {
        return (
            <SuccessMessage
                {...rest}
            />
        )
    }

    if (status === RequestStatuses.FAILURE) {
        return (
            <FailureMessage
                {...rest}
            />
        )
    }

    return null
}

FinishedMessage.defaultProps = defaultProps

export default FinishedMessage
